import { isNullOrUndefined } from "util";


(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Helper, Config, View, Model, Handlebars, Constantes, Validation, Message, Controller, Analytics, $, IFrames, Hotjar) {
    'use strict';

    var meses = {
        '0': 'Enero',
        '1': 'Febrero',
        '2': 'Marzo',
        '3': 'Abril',
        '4': 'Mayo',
        '5': 'Junio',
        '6': 'Julio',
        '7': 'Agosto',
        '8': 'Septiembre',
        '9': 'Octubre',
        '10': 'Noviembre',
        '11': 'Diciembre'
    };

        // ==================================================
    // Obtiene la descripcion del mes
    // Params : {Date}
    // ==================================================   
    Helper.getMonthDescription = function (date) {
        if (typeof date != 'object') {
            date = new Date(date);
        }
        return meses[date.getMonth()];
    }

    // ==================================================
    // Setea el titulo de la pagina
    // Params : {string}
    // ==================================================    
    Helper.setPageTitle = function (title) {
        document.title = title;
    }

    Helper.setFirstStart = function (bool) {
        Model.Window.firstStart = bool;
    }

    Helper.checkFirstStart = function () {
        return Model.Window.firstStart;
    }

    // ==================================================
    // Redireccion
    // Params : {string}
    // ==================================================   
    Helper.redirectUrl = function (url) {
        window.location = url;
    }

    // ==================================================
    // Muestra preloader
    // ==================================================
    Helper.showPreloader = function () {
        $(document.body).addClass("loading").each(function () {
            //
        });
    }

    // ==================================================
    // Oculta preloader
    // ==================================================
    Helper.hidePreloader = function () {
        $(document.body).removeClass("loading").each(function () {
            $('.preloader').css('display', 'none');
        })
    }

    Helper.removeBlur = function () {
        $('#main-view').removeClass("loading");
    }

    // ==================================================
    // Valida si esta vacio cualquier tipo de dato
    // Params : {obj} || {arr} || {str}
    // ==================================================
    Helper.isEmpty = function (obj) {
        if (obj == null) return true;
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }


    Helper.setToken = function (token) {
        if (Helper.isEmpty(token)) return;
        Helper.createCookie('token', token, Config.cookieExpirationTime, Config.dominioCookie);
        Model.Usuario.xToken = token;
    }

    Helper.updateToken = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
    }

    Helper.setXValue = function (xvalue) {
        if (Helper.isEmpty(xvalue)) return;
        Helper.createCookie('xvalue', xvalue, Config.cookieExpirationTime, Config.dominioCookie);
        Model.Usuario.xValue = xvalue;
    }

    // ==================================================
    // Setea en cookies todo un objeto
    // ==================================================
    Helper.setupCookies = function (obj) {
        for (var key in obj) {
            var aux;
            var cookie;
            // Busco si la key se encuentra en el diccionario de cookies para ver si la grabo o no . 
            if (Config.DiccionarioCookiesAGuardar.indexOf(key) > -1 && typeof obj[key] == "string") {
                switch (key) {
                    case 'UsuarioDetalleGuid':
                        aux = "usuario%5Fdetalle%5Fguid";
                        cookie = '{' + Helper.readCookie("token") + '}';
                        break;
                    case 'UsuarioDetalleNick':
                        aux = "usuario%5Fdetalle%5Fnick";
                        cookie = obj[key];
                        break;
                    case 'UsuarioId':
                        aux = "usuario%5Fid";
                        cookie = obj[key];
                        break;
                    case 'UsuarioUsuario':
                        aux = "usuario%5Fusuario";
                        cookie = obj[key];
                        break;
                    case 'usuarioLogTkn':
                        aux = "usuario%5Flogtkn";
                        cookie = obj[key];
                        break;
                    case 'TokenJWT':
                        aux = "PersoTKN";
                        cookie = obj[key];
                        break;
                    default:
                        aux = key;
                        cookie = obj[key];
                }
                //console.log("Create Cookie - Name : " + aux + " - Value : " + cookie);
                Helper.createCookie(aux, cookie, Config.cookieExpirationTime, Config.dominioCookie);
            }
        }
    }

    // ==================================================
    // Crea una cookie
    // Params : {str} {str} {str} {str}
    // ==================================================
    Helper.createCookie = function (name, value, seconds, domain) {
        var expires;
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + (seconds * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }

        if (document.domain === 'localhost') {
            document.cookie = name + "=" + value + expires + "; path=/";
        } else {
            document.cookie = name + "=" + value + expires + ";domain=" + domain + "; path=/";
        }
    }

    // ==================================================
    // Lee el valor de una cookie
    // Params : {str}
    // ==================================================   
    Helper.readCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // ==================================================
    // Borra todas las cookies
    // ==================================================   
    Helper.deleteAllCookies = function () {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

            if (Config.DiccionarioCookiesAGuardar.indexOf(name.trim()) > -1) {
                if (document.domain === 'localhost') {
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
                } else {
                    //console.log("Delete Cookie - Name : " + name);
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
                }
            }
        }
    }

    // ==================================================
    // Borra cookie según nombre dado 
    // ==================================================   
    Helper.deleteCookie = function (name) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
    }

    // ==================================================       
    Helper.setCanSubmit = function (bool) {
        Model.Window.canSubmit = bool;
    }

    Helper.canSubmit = function () {
        return Model.Window.canSubmit;
    }

    // ==================================================
    // Trae Todos los inputs del dom
    // ==================================================   
    Helper.getAllInputs = function () {
        var inputs = $(':input');
        var values = {};
        inputs.each(function () {
            values[this.name] = $(this).val();
        });
        return values;
    }

    // ==================================================
    // Trae Todos los inputs del dom y los convierte a un objeto
    // ==================================================   
    Helper.getAllInputsObject = function () {
        var inputs = $(':input');
        return inputs;
    }

    // ==================================================
    // Extrae un parametro de la current url
    // ==================================================   
    Helper.getURLParameter1 = function (n) {
        return decodeURIComponent((new RegExp('[?|&]' + n + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }

    Helper.getURLPath = function () {
        var pathArray = window.location.pathname.split('/');
        return pathArray[1];
    }

    Helper.getSource = function () {
        return Model.Window.source;
    }

    Helper.getURLParameter = function (n) { //deprecado
        
        var pathArray = window.location.pathname.replace("/suscripcion/", "").replace("/que-es-acceso-digital/", "").replace("/acceso-digital/", "").replace('/validar-pin/', '').split('/');
        switch (n) {
            case 'param1':
                return (!Helper.isEmpty(pathArray[0])) ? pathArray[0] : null;
                break;
            case 'param2':
                return (!Helper.isEmpty(pathArray[1])) ? pathArray[1] : null;
                break;
            case 'param3':
                return (!Helper.isEmpty(pathArray[2])) ? pathArray[2] : null;
                break;
            case 'param4':
                return (!Helper.isEmpty(pathArray[3])) ? pathArray[3] : null;
                break;
            default:
                return null;
                break;
        }
    };


    Helper.getURLPathParameter = function (n) {
        var pathArray = window.location.pathname.split('/');
        switch (n) {
            case 'param1':
                return (!Helper.isEmpty(pathArray[2])) ? pathArray[2] : null;
                break;
            case 'param2':
                return (!Helper.isEmpty(pathArray[3])) ? pathArray[3] : null;
                break;
            case 'param3':
                return (!Helper.isEmpty(pathArray[4])) ? pathArray[4] : null;
                break;
            case 'param4':
                return (!Helper.isEmpty(pathArray[5])) ? pathArray[5] : null;
                break;
            default:
                return null;
                break;
        }
    };

    Helper.redirectToLogin = function (url) {
        var encode_url = window.btoa(Model.Window.location);
        if (!Helper.isEmpty(url)) encode_url = window.btoa(url);
        LN.AppEvent.sendEvent('REDIRECT',window.atob(encode_url));
        if (Model.Embed.Mobile) {
            return;
        }
        if (Model.Embed.Article) {
            encode_url = encode_url + '&article=' + true;
        }
        Helper.redirectUrl(Config.dominioIngresar + encode_url);
    }

    const AppendMultipleParams = (url, keys, values) =>
    {
        let i = 0;
        for (i in keys) {
            url = AppendToUrl(url, keys[i], values[keys[i]]);
        }
        return url;
    }  


    const AppendToUrl = (url, key, value) => {
        if ((url).indexOf('?') == -1) {
            url = url + '?';
        }
        else {
            url = url + '&';
        }
        url = url + key + '=' + value;
        return url;

    }

    const urlBuilder = (url) => {
        if (Model.canalDeVenta != 0) {
            url = AppendToUrl(url, 'cv', Model.canalDeVenta);
        }
        if (Model.Window.contact != 0) {
            url = AppendToUrl(url, 'fc', Model.Window.contact);
        }
        if (Model.productCategory != 0) {
            url = AppendToUrl(url, 'productCategory', Model.productCategory);
        }
        if (Model.Window.pagina) {
            url = AppendToUrl(url, 'callback', window.btoa(Model.Window.pagina));
        }
        if (Model.ExternalPaywall.Name) {
            url = AppendMultipleParams(url, Model.ExternalPaywall.Params, Model.ExternalPaywall.Values);
        }

        return url;

    }

    Helper.redirectToLoginWAction = function (accion) {
        //redirecciona a login para que vuelva a una pagina de accion /A/1/?algo... EJ YA TENGO..
        let url = Config.urlRedirectAccion + accion + '/?';
        url = urlBuilder(url);
        let encode_url = window.btoa(url);
        LN.AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
        if (Model.Embed.Mobile) {
            return;
        }
        encode_url = Config.dominioIngresar + encode_url;
        if (Model.Embed.Article) {
            encode_url = AppendToUrl(encode_url, 'article', true);
        }
        Helper.redirectUrl(encode_url);
    }

    Helper.redirectToLoginWReturnAction = function (url, action) {
        let currentLocation = Model.Window.location;
        if (!Helper.isEmpty(url)) currentLocation = Model.Window.origin + url;
        if (action) {
            if (currentLocation.includes('?')) {
                currentLocation = currentLocation + '&a=' + action;
            } else {
                currentLocation = currentLocation + '/?a=' + action;
            }
        }
        var encode_url = window.btoa(currentLocation);
        LN.AppEvent.sendEvent('REDIRECT', currentLocation);
        if (Model.Embed.Mobile) {
            return;
        }
        Helper.redirectUrl(Config.dominioIngresar + encode_url);
    }

    Helper.redirectToLoginWCombo = function (combo) {
        //redirecciona a login para que vuelva a una pagina de Compra /C/14/?algo... carrito
        let url = Config.urlRedirect + combo + '/?';
        url = urlBuilder(url);
        let encode_url = window.btoa(url);
        LN.AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
        if (Model.Embed.Mobile) {
            return;
        }
        encode_url = Config.dominioIngresar + encode_url;
        if (Model.Embed.Article) {
            encode_url = AppendToUrl(encode_url, 'article', true);
        }
        Helper.redirectUrl(encode_url);
    }

    Helper.redirectToPaywall = function (accion, combo) {
        let url = Config.urlSuscripciones + accion + '/' + combo + '/';
        url = urlBuilder(url);
        LN.AppEvent.sendEvent('REDIRECT', url);
        if (Model.Embed.Mobile) {
            return;
        }
        Helper.redirectUrl(url);
    }

    Helper.getURLQueryString = function () {
        return window.location.search.replace("?", "");
    }

    Helper.removeCustomClass = function () {
        $(document.body).removeClass(function (index, className) {
            return (className.match(/(^|\s)custom-\S+/g) || []).join(' ');
        });
    }

    Helper.addCustomClass = function (c) {
        $(document.body).addClass(c);
    }


    // ==================================================
    // Helpers Custom
    // ================================================== 

    // ==================================================
    // Setea el step actual en el modelo Window
    // ==================================================     
    Helper.setCurrentStep = function (step) {
        Model.Window.currentStep = step;
    }

    Helper.getCurrentStep = function () {
        return Model.Window.currentStep;
    }

    Helper.setCurrentLayout = function (layout) {
        Model.Window.currentLayout = layout;
    }

    Helper.getCurrentLayout = function () {
        return Model.Window.currentLayout;
    }

    Helper.callView = function (view, data, cb, reload) {
        Helper.addStep(view, data, cb, reload);
    }

    // ==================================================
    // Valida si el modo en la URL esta permitido (Se saca desde config.js)
    // ================================================== 
    Helper.modoPermitido = function (modo) {
        if (Config.Modos.indexOf(modo) == -1) return false;
        return true;
    }

 
    // ==================================================
    // Valida si el sitio en la URL esta permitido (Se saca desde config.js)
    // ================================================== 
    Helper.sitioPermitido = function (sitio) {
        if (Config.Sitios[sitio] == null) return false;
        return true;
    }

    Helper.ocultarMail = function (email) {
        if (email != null && email != "" && email != "undefined") {
            var hasta = email.indexOf('@');
            var dominio = email.substring(hasta, email.length);
            var nombreMail = email.substring(0, 1) + "****";
            nombreMail += dominio;
            return nombreMail;
        }
        return "";
    }

    Helper.getTemplateAjax = function (step, path, data, selector, cb) {
        var viewContent = {
            Config: Config,
            Model: Model,
            Data: data,
            Message: Message,
            Constantes: Constantes,
            Combo: function (combo, options) {
                let p = Model.getPlan(combo);
                if (p)
                    return options.fn(p);
                else
                    return options.inverse(this);
            },
            MonthLegend: function (meses) {
                if (!meses) return '';
                if (meses === 1) { return 'mes'; } else {
                    return 'meses';
                }
            },
            OneMonth: function (meses, options) {
                if (!meses) return false;
                if (meses === 1) return options.fn(true);
                return options.inverse(this);
            },
            PriceFormat: function (price) {
                if (isNullOrUndefined(price)) return '';
                return new Handlebars.SafeString(price.toFixed(2));
                //if (price % 1 != 0)// tiene decimales
                    
                //else
                //    return new Handlebars.SafeString(price.toString());
            },
            Ceil: function (price) {
                if (isNullOrUndefined(price)) return '';
                return new Handlebars.SafeString(Math.ceil(price));
            },
            CurrentMonth: function () {
                var date = new Date();
                return Helper.getMonthDescription(date);
            },
            NextMonth: function () {
                var date = new Date();
                date.setMonth(date.getMonth() +1 );
                return Helper.getMonthDescription(date);
            }
        }
        if (document.getElementById(step + "-template-from-server")) {
            console.log("step from server");
            CompileHandlebar(selector, viewContent, document.getElementById(step + "-template-from-server").innerHTML, cb);
        }
        else {
            $.ajax({
                url: path,
                cache: true
            }).done(function (res, status, xhr) {
                CompileHandlebar(selector, viewContent, res, cb);
            });
        }
    }

    let CompileHandlebar = function (selector, viewContent, source, cb)
    {
        let template = Handlebars.compile(source);
        $(selector).html(template(viewContent)).each(function () {
            cb && cb();
        });
    }

    Helper.guid = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
    // ==================================================
    // Agrega una nueva vista reemplazando la actual
    // step = Step valido sacado de config.js
    // data = Todas las vistas tienen objeto de referencia llamado Data para ser usado por handlebars al compilar, se envia en forma de objeto 
    // cb = callback post ejecucion
    // reload = true / false Esto permite forzar el reload de una pantalla si lo requisiera
    // ==================================================     
    Helper.addStep = function (step, data, cb, reload) {

        var currentStep = Helper.getCurrentStep();
        var stepFile = Config.Blocks[step].file;
        var stepCustomClass = Config.Blocks[step].class;
        var stepLayout = Config.Layouts[Config.Blocks[step].layout].file;
        var stepLayoutClass = Config.Layouts[Config.Blocks[step].layout].class;
        var flow = Config.Blocks[step].flow;
        var data = data || {};
        Helper.setPageTitle(Config.Blocks[step].title);
        if (flow.length > 0 && flow.indexOf(currentStep) === -1) throw new Error("Flow no permitido");

        // si queres ejecutar el mismo flow devuelve true
        //console.log(currentStep,stepFile)
        //if (!Helper.isEmpty(currentStep) && !Helper.isEmpty(stepFile) && (currentStep === stepFile)) return true;

        LN.Helper.showPreloader();
        // Pregunto si esta el layout cargado de este step
        if (document.getElementById(stepLayout) === null || reload) {
            $(document.body).fadeOut('fast', function () {
                Helper.getTemplateAjax(stepLayout, Config.urlLayouts + stepLayout, data, document.body, function () {
                    // Agrego la class al body desde el config
                    $(document.body).removeClass().addClass(stepLayoutClass);
                    // Pregunto si el step o block esta cargado o necesita recargarse
                    if (!Helper.isEmpty(stepFile)) {
                        if (document.getElementById(stepFile) === null || reload) {
                            $('#main-block').fadeOut('fast', function () {
                                Helper.getTemplateAjax(stepFile, Config.urlBlocks + stepFile, data, '#main-block', function () {
                                    // Quito las custom class del body si existiera
                                    Helper.removeCustomClass();
                                    // Agrego la custom class
                                    Helper.addCustomClass(stepCustomClass);
                                    $('.steps').addClass('hide').each(function (index, el) {
                                        // Valida si es landing o formuarios         
                                        Helper.cleanKeyPress();
                                        Helper.hidePreloader();
                                        Helper.explorador();
                                        Helper.disableTop();
                                        Helper.quickView();
                                        Helper.addReturnBackArrow();
                                        Helper.placeHolderAnimationOnStepLoad();
                                        // Muestro el body y el contenido
                                        $(document.body).fadeIn('fast').each(function () {
                                            $('#main-block').fadeIn('fast');
                                        });
                                        if (Model.PlanElegido) {
                                            Analytics.paginaVirtual(stepFile, Model.PlanElegido.nombre);
                                        } else {
                                            Analytics.paginaVirtual(stepFile, null);
                                        }
                                        if (Helper.checkFirstStart() === false) {
                                            (typeof (ga) !== "undefined") && ga('set', 'page', '/' + stepFile);
                                            (typeof (ga) !== "undefined") && ga('send', 'pageview');
                                        }
                                        Helper.setFirstStart(false);
                                        Hotjar.tagRecording([stepFile]);
                                        cb && cb();
                                    });
                                })
                            });
                        }
                    } else {
                        // Pagina sin bloques
                        $(document.body).fadeIn('fast');
                        if (Model.PlanElegido) {
                            Analytics.paginaVirtual(stepLayout, Model.PlanElegido.nombre);
                        } else {
                            Analytics.paginaVirtual(stepFile, null);
                        }
                        Helper.quickView();
                        cb && cb();
                    }
                })
            });
        } else {
            // Si ya esta cargado el layout
            if (!Helper.isEmpty(stepFile)) {
                if (document.getElementById(stepFile) === null || reload) {
                    $('#main-block').fadeOut('fast', function () {
                        Helper.getTemplateAjax(stepFile, Config.urlBlocks + stepFile, data, '#main-block', function () {
                            // Quito las custom class del body si existiera
                            Helper.removeCustomClass();
                            // Agrego la custom class
                            Helper.addCustomClass(stepCustomClass);
                            $('.steps').addClass('hide').each(function (index, el) {
                                Helper.cleanKeyPress();
                                Helper.hidePreloader();
                                Helper.explorador();
                                Helper.disableTop();
                                Helper.quickView();
                                Helper.addReturnBackArrow();
                                Helper.placeHolderAnimationOnStepLoad();
                                if (Model.PlanElegido) {
                                    Analytics.paginaVirtual(stepFile, Model.PlanElegido.nombre);
                                } else {
                                    Analytics.paginaVirtual(stepFile, null);
                                }
                                // Muestro el body y el contenido
                                $(document.body).fadeIn('fast').each(function () {
                                    $('#main-block').fadeIn('fast');
                                })
                                cb && cb();
                            });
                        })
                    });
                }
            } else {
                // Pagina sin bloques
                $(document.body).fadeIn('fast');
                if (Model.PlanElegido) {
                    Analytics.paginaVirtual(stepLayout, Model.PlanElegido.nombre);
                } else {
                    Analytics.paginaVirtual(stepLayout, null);
                }
                cb && cb();
            }
        }
        Helper.setCurrentLayout(stepLayout);
        Helper.setCurrentStep(stepFile);
    }

    Helper.addReturnBackArrow = function () {
        if ($(".atras-form").length) $('#atras-header').attr('data-step', $(".atras-form").data('step'));
    }

    Helper.explorador = function () {
        // NAVEGADOR FIX
        var BrowserDetect = {
            init: function () {
                this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
                this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
                this.OS = this.searchString(this.dataOS) || "an unknown OS";
            },
            searchString: function (data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;
                    this.versionSearchString = data[i].versionSearch || data[i].identity;
                    if (dataString) { if (dataString.indexOf(data[i].subString) != -1) return data[i].identity; } else if (dataProp) return data[i].identity;
                }
            },
            searchVersion: function (dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index == -1) return;
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            },
            dataBrowser: [{ string: navigator.userAgent, subString: "Chrome", identity: "Chrome" }, { string: navigator.userAgent, subString: "OmniWeb", versionSearch: "OmniWeb/", identity: "OmniWeb" }, { string: navigator.vendor, subString: "Apple", identity: "Safari", versionSearch: "Version" }, { prop: window.opera, identity: "Opera", versionSearch: "Version" }, { string: navigator.vendor, subString: "iCab", identity: "iCab" }, { string: navigator.vendor, subString: "KDE", identity: "Konqueror" }, { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" }, { string: navigator.vendor, subString: "Camino", identity: "Camino" }, {  // for newer Netscapes (6+)
                string: navigator.userAgent,
                subString: "Netscape",
                identity: "Netscape"
            }, { string: navigator.userAgent, subString: "MSIE", identity: "Explorer", versionSearch: "MSIE" }, { string: navigator.userAgent, subString: "Gecko", identity: "Mozilla", versionSearch: "rv" }, {  // for older Netscapes (4-)
                string: navigator.userAgent,
                subString: "Mozilla",
                identity: "Netscape",
                versionSearch: "Mozilla"
            }],
            dataOS: [{ string: navigator.platform, subString: "Win", identity: "Windows" }, { string: navigator.platform, subString: "Mac", identity: "Mac" }, { string: navigator.userAgent, subString: "iPhone", identity: "iPhone/iPod" }, { string: navigator.platform, subString: "Linux", identity: "Linux" }]


        };
        BrowserDetect.init();
        var browserDetection = BrowserDetect.browser;
        var browserVersion = 'v' + BrowserDetect.version;
        var OSname = BrowserDetect.OS;
        $('body').addClass(browserDetection + ' ' + browserVersion + ' ' + OSname);
        // NAVEGADOR FIX
    }


    Helper.disableTop = function () {
        if ($('.cabezal-black').length) {
            $('main').addClass('login-black');
            $('#main-view').addClass('no-top');
            $(window).on("load", function (event) {
                if ($(this).width() < 999) {
                    $(".bottom-content, #contenedor>div").addClass('mobile');
                } else {
                    $(".bottom-content, #contenedor>div").removeClass('mobile');
                }
            });
        };
        $('body').scrollTop(0);
    }

    Helper.returnBack = function (options) {
        var pagina = ((!Helper.isEmpty(options) && !Helper.isEmpty(options.url)) ? options.url : Model.Window.pagina);
        if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
    }

    Helper.returnBackLogout = function (options) {
        var pagina = ((!Helper.isEmpty(options) && !Helper.isEmpty(options.url)) ? options.url : Model.Window.pagina);
        if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
    }

    Helper.changeStatus = function (selector, status, message, cb) {
        Helper.displayMessage(selector, status);
        Helper.hidePreloader();
        if (status == false && message) {
            selector.parent().find('span').html(message)
        } else if (selector.parent().find('span').hasClass('current')) {
            // Valido para el nice-select
        } else {
            selector.parent().find('span').html('');
        }
        cb && cb();
    }

    Helper.cleanStatus = function (selector) {

        if (!selector.parent().hasClass('input')) return;

        selector.removeClass("error");
        selector.removeClass("check");
        selector.parent().removeClass("error");
        selector.parent().removeClass("check");

        if (selector.parent().find('span').hasClass()) return;
        selector.parent().find('span').html('');
    }

    Helper.displayMessage = function (selector, status) {
        if (status) {
            selector.parent(".input").removeClass('error');
            selector.parent(".input").addClass('check');
        } else {
            selector.parent(".input").addClass('error');
            selector.parent(".input").removeClass('check');
        }
    }

    Helper.showBlockMessageError = function (s) {
        Helper.hidePreloader();
        $("." + s).css("display", "initial");
        var text = $("." + s).find('p').text();
        Analytics.error(text);
        var topError = $("." + s).offset().top;
        $("body, html").animate({
            scrollTop: topError - 100
        }, 500);
    }

    Helper.hideCustomMessageError = function (s) {
        //Helper.hidePreloader();
        $("." + s).css("display", "none");
    }

    Helper.placeHolderAnimation = function (obj, method) {
        obj.parent(".input").each(function () {
            $("label", this).css({
                "line-height": "20px",
                "font-size": "12px",
                "top": "0px",
            });
            $(".spin", this).css({
                "width": "100%"
            });
            if (method != "focus") $("input", this).focus();
        });
    }

    Helper.placeHolderAnimationOnStepLoad = function () {
        $('input').each(function () {
            if (!Helper.isEmpty($(this).val())) {
                //Helper.changeStatus($(this), true);
                Helper.enableNextButton();
                $(this).parent().find("label").css({
                    "line-height": "20px",
                    "font-size": "12px",
                    "top": "0px",
                });
            }
        });
    }

    Helper.checkNextButton = function (selector) {
        Helper.cleanStatusInputs();
        if (!Helper.isEmpty(selector.val())) Helper.enableNextButton();
        else Helper.disableNextButton();
    }

    Helper.enableNextButton = function () {
        $('.next-step').addClass('active');
        $('.next-step').prop("disabled", false);
    }

    Helper.disableNextButton = function () {
        $('.next-step').removeClass('active');
        $('.next-step').prop("disabled", true);
    }

    Helper.placeHolder = function () {
        //if ($('.mostrarPass').length > 0) {
        //Helper.showHide();
        //}   
        $(document.body).on('click', "div.input label", function (e) {
            e.preventDefault();
            Helper.placeHolderAnimation($(this), "click");
        });

        $(document.body).on('focus', "div.input input", function (e) {
            e.preventDefault();
            Helper.placeHolderAnimation($(this), "focus");
        });


        $(document.body).on('blur', "div.input input", function (e) {
            $(".spin").css({
                "width": "0px"
            });
            if ($(this).val() == "") {
                $(this).parent(".input").each(function () {
                    $("label", this).css({
                        "line-height": "33px",
                        "font-size": "14px",
                        "font-weight": "400",
                        "top": "15px",
                    });
                });
            }
        })
    };

    Helper.cleanSpecialCharsInput = function (str) {
        return Helper.removeDiacritics(Helper.removeSpecialChars(str));
    }

    Helper.removeSpecialChars = function (str) {
        return str.replace(/[^a-zA-ZÀ-ÿ ]/g, "")
    }

    Helper.removeDiacritics = function (str) {
        var defaultDiacriticsRemovalMap = [
            { 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g },
            { 'base': 'AA', 'letters': /[\uA732]/g },
            { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g },
            { 'base': 'AO', 'letters': /[\uA734]/g },
            { 'base': 'AU', 'letters': /[\uA736]/g },
            { 'base': 'AV', 'letters': /[\uA738\uA73A]/g },
            { 'base': 'AY', 'letters': /[\uA73C]/g },
            { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
            { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
            { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
            { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g },
            { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g },
            { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g },
            { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
            { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
            { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
            { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g },
            { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
            { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
            { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g },
            { 'base': 'LJ', 'letters': /[\u01C7]/g },
            { 'base': 'Lj', 'letters': /[\u01C8]/g },
            { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
            { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
            { 'base': 'NJ', 'letters': /[\u01CA]/g },
            { 'base': 'Nj', 'letters': /[\u01CB]/g },
            { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g },
            { 'base': 'OI', 'letters': /[\u01A2]/g },
            { 'base': 'OO', 'letters': /[\uA74E]/g },
            { 'base': 'OU', 'letters': /[\u0222]/g },
            { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
            { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
            { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g },
            { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g },
            { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
            { 'base': 'TZ', 'letters': /[\uA728]/g },
            { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g },
            { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
            { 'base': 'VY', 'letters': /[\uA760]/g },
            { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
            { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
            { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
            { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
            { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g },
            { 'base': 'aa', 'letters': /[\uA733]/g },
            { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g },
            { 'base': 'ao', 'letters': /[\uA735]/g },
            { 'base': 'au', 'letters': /[\uA737]/g },
            { 'base': 'av', 'letters': /[\uA739\uA73B]/g },
            { 'base': 'ay', 'letters': /[\uA73D]/g },
            { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
            { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
            { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
            { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g },
            { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g },
            { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
            { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
            { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
            { 'base': 'hv', 'letters': /[\u0195]/g },
            { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g },
            { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
            { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
            { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g },
            { 'base': 'lj', 'letters': /[\u01C9]/g },
            { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
            { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g },
            { 'base': 'nj', 'letters': /[\u01CC]/g },
            { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g },
            { 'base': 'oi', 'letters': /[\u01A3]/g },
            { 'base': 'ou', 'letters': /[\u0223]/g },
            { 'base': 'oo', 'letters': /[\uA74F]/g },
            { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
            { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
            { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g },
            { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g },
            { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
            { 'base': 'tz', 'letters': /[\uA729]/g },
            { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g },
            { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
            { 'base': 'vy', 'letters': /[\uA761]/g },
            { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
            { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
            { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
            { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }
        ];

        for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
            str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
        }
        return str;
    }

    Helper.initialpreloader = function () {
        //$(document.body).html('<div class="preloader-main"><span class="preloader-gif"></span></div>')
        $('.preloader').delay(400).fadeOut(500);
    }

    Helper.cleanInputs = function () {
        $('.input input').val('');
    }

    Helper.cleanStatusInputs = function () {
        $(".input").each(function () {
            if (($(this).hasClass("error") || $(this).hasClass("check")) && $(this).hasClass("no-validate-keyup") == false && $(this).find("input").val() !== 0) {
                Helper.cleanStatus($(this));
            }
        });
    }

    Helper.cleanInputName = function (s) {
        var n = s.attr("name").match(/\[.*?\]/);
        var o = n[0].replace("[", "").replace("]", "");
        return o;
    }

    Helper.globalResize = function () {
        Model.Window.width = $(window).width();
        Model.Window.height = $(window).height();
    }

    Helper.carrito = function () {
        /*defino el alto para el despelgable dinamico*/
        var altoCarro = $(".carrito").height() - 60;
        $(".carrito").css({ "bottom": "-" + altoCarro + "px" });
         
        /*carrito click despelgable dinamico*/
        $(".carrito > div:first-child").off('click').on("click", function () {
            var flechita = $(".carrito > div:first-child > span:first-child");
            $(".carrito").toggleClass("abrir");

            if ($(".carrito.abrir").length > 0) {
                flechita.removeClass("icon-arrow-up");
                flechita.addClass("icon-arrow-down");
            } else {
                flechita.removeClass("icon-arrow-down");
                flechita.addClass("icon-arrow-up");
            }
        });
        //para que el loader quede siempre en el medio dependiendo del tamaño del main
        $('.preloader-gif').css({ 'left': $('main').width() / 2 + 'px' });

        //hacemos que el carrito se oculte cuando se despliega el teclado.
        const $carrito = document.querySelector('.carrito');
        const altoInicial = window.innerHeight;

        window.addEventListener('resize', function () {
            if (window.innerHeight !== altoInicial) {
                $carrito.style.display = "none";
            } else {
                $carrito.style.display = "block";
            }
        }, true);

    }

    Helper.yaCompraste = function () {
        //cambios en el carrito cuadno compra DESKTOP
        $('.call').css({ 'display': 'none' });
        $('.recordar').css({ 'display': 'none' });
        $('.icon-carrito').addClass('move');
        $('.producto h3').addClass('bounceOutRight');
        setTimeout(function () {
            $('.producto h3').html('Compraste');
            $('.producto h3').removeClass('bounceOutRight');
            $('.producto h3').addClass('fadeInUp2');
            $('.producto div.icon-carrito div:first-child').addClass('zoomIn');
        }, 1000);
    }
    // on resize
    Helper.onResize = function () {
        Model.Window.width = $(window).width();
        Model.Window.height = $(window).height();
    }

    Helper.cleanKeyPress = function () {
        Model.Window.keyPress = 0;
    }

    // ==================================================
    // Limpia el modelo, cookies y resetea parametros de URL
    // ==================================================   
    Helper.resetAll = function (cb) {
        $(':input').val('');
        for (var index in Model.Usuario) {
            Model.Usuario[index] = '';
        }
        Helper.deleteAllCookies();
        Model.Usuario.SitioId = Model.Window.SitioId;
        cb && cb();
    }

    Helper.showModalAddress = function () {
        $(".modal_address").fadeIn();

        if (Model.getInputsBy("datos_envio", 'pais').get().value != "AR") {
            $(".form-digital-exterior").css("display", "initial");
            $(".form-digital").css("display", "none");
        } else {
            $(".form-digital-exterior").css("display", "none");
            $(".form-digital").css("display", "initial");
        }

    }

    Helper.hideButtonNewAddress = function () {
        $("#nuevo-dom").fadeOut();
    }

    Helper.hideModalAddress = function () {
        $(".modal_address").fadeOut();
    }

    Helper.checkIfAddressExist = function (address) {
        for (var i in Model.Domicilios) {
            if (Model.Domicilios[i].domicilio === address.calle + ' ' + address.altura) return Model.Domicilios[i].id;
        }
        return false;
    }

    Helper.selectAddressRadio = function (id) {

        $(".toggle-nuevo-dom").prop("disabled", true);

        $(':input[name="datos_envio[selector]"]').each(function () {
            if ($(this).val() === id) {
                $(this).prop('checked', true);
                $(this).prop('disabled', false);
                Model.getInputsBy("datos_envio", 'id').set(id)
                // Toggle al menu de nuevo domicilio
                if ($(".nuevo-dom").is(':visible')) {
                    Model.getInputsBy("datos_envio").clean();
                    $(".nuevo-dom").toggle();
                }
                return true;
            }
        });


    }


 
    // ==================================================
    // Obtiene la IP local/publica a traves de webrtc
    // ==================================================    


    Helper.getClientIP = function () {
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        var client = new RTCPeerConnection({ iceServers: [] }),
            noop = function () { };
        client.createDataChannel(""); //create a bogus data channel
        client.createOffer(client.setLocalDescription.bind(client), noop); // create offer and set local description
        client.onicecandidate = function (ice) { //listen for candidate events
            if (!ice || !ice.candidate || !ice.candidate.candidate) return;
            var ip = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
            Model.Window.ip = ip;
            client.onicecandidate = noop;
        };
    }
    

    Helper.eventosDatosPersonales = function () {
        /* $(document).on('change', 'input[name="datos_personales[tipo_documento]"]', function(e) {
             var optionSelected = $('input[name="datos_personales[tipo_documento]"] option:selected').val();
             (optionSelected == 'PAS') ? $('input[name="datos_personales[tipo_documento]"]').attr('type', 'text'): $('input[name="datos_personales[tipo_documento]"]').attr('type', 'number');
         });        */
        /*FUNCION CENTRAR LOAD EN MAIN*/
        var mainWidth = $("main").width();
        mainWidth = mainWidth / 2;
        $('.preloader .preloader-gif').css({ 'left': mainWidth + 33 + 'px' });

        /*FUNCION TOOLTIP*/
        $('.icon-ayuda').click(function () {
            if ($(".visible").length > 0) {
                $('.tooltip').fadeOut();
                $('.tooltip').removeClass("visible");
            } else {
                $('.tooltip').fadeIn();
                $('.tooltip').addClass("visible");
            }
            return false;
        });
        $('body').click(function () {

            if ($(".visible").length > 0) {
                $('.tooltip').fadeOut();
                $('.tooltip').removeClass("visible");
            }
        });

        $(':radio[name="datos_personales[selector_residencia]"]').change(function () {
            $(this).prop('checked', true);

            Model.getInputsBy("datos_personales", 'residencia').set($(this).val());
            if (Model.PlanElegido.planConCredencial) {
                if ($(this).val() == 'true') {
                    // Es extranjero
                    $(".modal_country").fadeIn();
                    $(".modal_country, .modal-pais span button").on("click", function () {
                        $(".modal").fadeOut();
                    });
                     $("#plan_elegido_imagen").attr('src',Model.PlanElegido.imagenExtranjera);
                } else {
                    $("#plan_elegido_imagen").attr('src', Model.PlanElegido.imagen);
                    //$("#plan_elegido_nombre").html(combo.nombre);
                    // $("#plan_elegido_nombre_mobile").html(combo.nombre);
                }
            }
        });

       // (Model.Cliente.comboElegido == Config.COMBO_ACCESO_DIGITAL) ? $(".carrito .tarjeta-premium").hide() : null;

        if($(window).width() > 768 )
             $(".nombre").focus();
        }

    Helper.eventosInicio = function () {
        // Acción de click en todo el btn suscribirme
        $(".btn-principal").click(function (event) {
            Controller.inicio(event.data('combo'));
        });
    };

    Helper.mostrarDetalles = function () {
        let $mostrarMas = document.querySelectorAll('.combo__detalles__button');
        Array.from($mostrarMas).map((item) => {
            item.addEventListener('click', (event) => {
                const $comboDetalles = event.target.parentNode;
                if ($comboDetalles.classList.contains('--activo')) {
                    $comboDetalles.classList.remove('--activo');
                    event.target.innerHTML = "Mostrar detalles";
                } else {
                    $comboDetalles.classList.add('--activo');
                    event.target.innerHTML = "Ocultar detalles";
                }
            });
        });
    };

    Helper.eventosInicioMuroNuevo = function () {

        //===========================
        //Animacion combos
        //===========================
        
            //------Funcion para agregar una misma fn a varios metodos del eventListener //
            function addListenerMulti(el, s, fn) {
                s.split(' ').forEach(e => el.addEventListener(e, fn, false));
            }

            //-----funcion que realiza el evento cuando la seccion se visualiza en el monitor en el primer render o se llega mediante scroll------
            let elementView = ($section, Hagamoslo, parametros) => {
                if (parametros.PANTALLA_BOTTOM > $section.offsetTop && parametros.PANTALLA_ARRIBA < $section.offsetTop + $section.offsetHeight) {
                    Hagamoslo();
                }
            };

            //------funcion en el cual recorre un all y le asigna un valor de aniamcion------     
            let visibleArticle = (elemento, animacion, delay) => {
                let num = 0;
                 // hago el undefined poruqe si viene un solo elemento el Array.from rompe
                if (elemento.length !== undefined) {
                    Array.from(elemento).map((item) => {
                        item.classList.add(animacion);
                        item.style.animationDelay = num + 's';
                        num += delay;
                    });
                } else {
                    elemento.classList.add(animacion);
                    elemento.style.animationDelay = num + 's';
                }
            };

            //------Aca armamos todos los elementos que queremos que participen en esta hermosa fiesta------
            let EyesViews = () => {
                let PANTALLA_ARRIBA = window.pageYOffset;
                let PANTALLA_TAMANIO_Y = window.innerHeight;
                let PANTALLA_BOTTOM = PANTALLA_ARRIBA + PANTALLA_TAMANIO_Y;
                let parametros = {
                    PANTALLA_ARRIBA: PANTALLA_ARRIBA,
                    PANTALLA_TAMANIO_Y: PANTALLA_TAMANIO_Y,
                    PANTALLA_BOTTOM: PANTALLA_BOTTOM
                };
                //animacion en scroll para preguntas frecuentes
                const $pregFrecuentesImg = document.querySelector('.preg-frecuentes__imgs');
                const $preFrecuentes = document.querySelector('.preg-frecuentes__descrip');
                const $preFrecuentesArticle = document.querySelectorAll('.preg-frecuentes__descrip article');
                if ($pregFrecuentesImg !== null) {
                    elementView($preFrecuentes, () => { visibleArticle($preFrecuentesArticle, 'fadeInUp', 0.4); }, parametros);
                    elementView($pregFrecuentesImg, () => { visibleArticle($pregFrecuentesImg, 'fadeInUp', 0.6); }, parametros);
                }
                //animacion en scroll para Contacto
                const $contacto = document.querySelector('.contacto');
                if ($contacto !== null) {
                    const $contactoH6 = document.querySelector('.contacto h6');
                    const $lineaContacto = document.querySelector('.contacto .separador-gris');
                    elementView($contacto, () => { visibleArticle($contactoH6, 'fadeInUp', 0.8); }, parametros);
                    elementView($contacto, () => { visibleArticle($lineaContacto, 'dibuje', 1); }, parametros);
                }

                //animacion para suscripcion a diarios y revistas
                const $suscripDiarios = document.querySelector('.suscrip-diarios');
                if ($suscripDiarios !== null) {
                    const $suscripDiariosTitulo = document.querySelector('.suscrip-diarios__titulo');
                    const $suscripDiariosCaja = document.querySelector('.suscrip-diarios__caja');
                    elementView($suscripDiarios, () => { visibleArticle($suscripDiariosTitulo, 'fadeInUp', 0.8); }, parametros);
                    elementView($suscripDiarios, () => { visibleArticle($suscripDiariosCaja, 'fadeInUp', 0.8); }, parametros);
                }

                //Animacion en Data-Fiscal
                const $dataFiscal = document.querySelector('.data-fiscal');
                const $lineaDataFiscal = document.querySelector('.data-fiscal .separador-gris');
                if ($dataFiscal !== null) {
                    elementView($dataFiscal, () => { visibleArticle($lineaDataFiscal, 'dibuje', 0.8); }, parametros);
                }
            };

            EyesViews();

            addListenerMulti(window, 'scroll', EyesViews);


        // Expandir mostrar mas . 
        let $mostrarMas = document.querySelectorAll('.combo__detalles__button');
        Array.from($mostrarMas).map((item) => {
            item.addEventListener('click', (event) => {
                const $comboDetalles = event.target.parentNode;
                if ($comboDetalles.classList.contains('--activo')) {
                    $comboDetalles.classList.remove('--activo');
                    event.target.innerHTML = "Mostrar detalles";
                } else {
                    $comboDetalles.classList.add('--activo');
                    event.target.innerHTML = "Ocultar detalles";
                }
            }); 
        });
    }

  Helper.TieneProductoPremiumPDF = function () {
    const ppCookie = Helper.readCookie("ProductoPremiumId");
    if (ppCookie) {
      var ids = ppCookie.split(",");
      if (ids.includes("3")) {
        return true;
      }
    }
    return false;
  }

  Helper.TieneAccesoDigital = function () {
    const ppCookie = Helper.readCookie("ProductoPremiumId");
    if (ppCookie) {
      var ids = ppCookie.split(",");
      if (ids.includes("2")) {
        return true;
      }
    }
    return false;
  }

  Helper.eventosInicioWall = function () {
    $(window).on('storage', function (ev) {
      if (ev.originalEvent.key !== 'userLogedIn') return; // ignore other keys
      var message = JSON.parse(ev.originalEvent.newValue);
      if (!message) return; // ignore empty msg or msg reset

      if (message === true) {
        const ppCookie = Helper.readCookie("ProductoPremiumId");
        if (ppCookie) {
          var ids = ppCookie.split(",");
          if (ids.includes("2")) {
            var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
            if (Helper.getURLParameter1('callback') != null) {
              if (base64Matcher.test(LN.Helper.getURLParameter1('callback'))) {
                let redirectUrl = Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback'))) ? window.atob(Helper.getURLParameter1('callback')) : "";
                if (redirectUrl)
                  Helper.redirectUrl(redirectUrl);
              }
            }

          }
        }
      }
      });
  }

  Helper.eventosInicioSuscribirme = function () {
    $("section.linea").each(function () {
      var widthContenedor = $(this).width();
      var widthTitulo = $(this).children("div:nth-child(2)").width();
      var elementoLineas = $(this).children("div.lineas");
      var promedio = widthContenedor - widthTitulo - 40;
      var total = promedio / 2;
      $(elementoLineas).css("width", total);
      $(this).find("h3").addClass("zoomIn");
      $(this).find("hr").addClass("write");
    });

    setTimeout(function () {
      $(".combo").addClass("fadeInUp2");
      if ($(window).width() >= 760) {
        $(".tarjeta").addClass("bounceInUp");
      }
      setTimeout(function () {
        $(".combo").css("animation-name", "none");
      }, 1900);
    }, 500);
    }

    Helper.eventosInputIngresarDocumento = function (inputName) {
        $('input[name="' + inputName + '"]').on("keyup", function (e) {
            if (e.keyCode == 190 || e.keyCode == 110) {
                if ($('select[name*="[tipoDocumento]"] option:selected').val() != 'PAS')
                    $('input[name="' + inputName + '"]').val("");
            }
        });

        $('.nro-documento').focus();

        var func = function () {
            var optionSelected = $('select[name*="[tipoDocumento]"] option:selected').val();
            (optionSelected == 'PAS') ? $('input[name="' + inputName + '"]').attr('type', 'text') : $('input[name="' + inputName + '"]').attr('type', 'number');
        }
        $('select[name*="[tipoDocumento]"]').on('change', function (e) {
            func();
        });
        func();

        var mainWidth = $("main").width();
        mainWidth = mainWidth / 2;
        $('.preloader .preloader-gif').css({ 'left': mainWidth + 33 + 'px' });

    }

    Helper.EventosNewsletter = function () {
        $(".newsletter-check").click(function (e) {
            if (e.target.checked) {
                Model.Newsletter.push(e.target.dataset.id);
            }
            else {
                let index = Model.Newsletter.indexOf(e.target.dataset.id);
                if (index > -1) {
                    Model.Newsletter.splice(index, 1);
                }
            }

        })
    }

    Helper.eventosPago = function () {
       
        $('#hidden-form').submit();
        IFrames.ValidarPago(function (data) {
            Controller.validarPago(data);
        });
        var preguntasfrecuentes = Config.dominioMiCuenta + "/tyc-acceso-digital-app";
        IFrames.TYC(function (data) {
            console.log('TYC');
            LN.AppEvent.sendEvent('TYC');
            if (Model.Embed.Mobile) {
                window.open(preguntasfrecuentes);
            }
        });
    }

    Helper.setIframeHeight = function () {     
        IFrames.Height(function (data) {           
            $("iframe.document-height").css({ "height": data + 50 + "px" });
        });
    }

    Helper.Ingreso_dni_MostrarMailOfuscado = function () {
        $("#mail").text(Model.Cliente.mailOfuscado);

        /* Display error */
        var text = $("#mailofuscado").find('p').text();

        Analytics.formError('numeroDocumento-El documento está asociado a otra cuenta');
        //Analytics.error(text.trim());        

        $("#mailofuscado").show();

    }

    Helper.quickView = function () {
        if (Config.enableQuickView === false) return true;
        if (!$('#debug').is(':empty')) return true;

        var views = Object.getOwnPropertyNames(LN.View);
        var debug = document.getElementById("debug")[0];
        for (var i in views) {
            var button = $('<button/>').addClass("next-button").attr('data-step', 'quick_view').attr('data-view', views[i]).html(views[i]);
            $('#debug').append(button).append('<br />');
        }
    }


    Helper.eventosDatosEnvios = function () {

        $("#country").on("click", function (e) {
            e.preventDefault();
            $(".country").slideToggle(250);
        });
        $(".codigo-postal").focus();
        



    }


    /*Extension helpers Handlebars*/
    Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
        if (arguments.length < 3)
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        var operator = options.hash.operator || "==";
        var operators = {
            '==': function (l, r) { return l == r; },
            '===': function (l, r) { return l === r; },
            '!=': function (l, r) { return l != r; },
            '<': function (l, r) { return l < r; },
            '>': function (l, r) { return l > r; },
            '<=': function (l, r) { return l <= r; },
            '>=': function (l, r) { return l >= r; },
            'typeof': function (l, r) { return typeof l == r; }
        }
        if (!operators[operator])
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
        var result = operators[operator](lvalue, rvalue);
        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('checkProductPremium', function (options) {
        var product = Helper.readCookie('ProductoPremiumId');
        if ((product != null || product != '') && !Helper.isEmpty(Model.Usuario.xToken)) {
            return options.inverse(this);
        }
        return options.fn(this);
    });

    Handlebars.registerHelper('NotProductPremium', function (options) {
        var product = Helper.readCookie('ProductoPremiumId');

        if (product && product != null && !Helper.isEmpty(Model.Usuario.xToken))
        {
            return new Handlebars.SafeString('<span class="chapita-conSuscrip">SUSCRIPTOR DIGITAL</span>');
        }
        return new Handlebars.SafeString('<span class="chapita-sinSuscrip">SIN SUSCRIPCI&Oacute;N DIGITAL</span>');

        //if ((product != null || product != '') && !Helper.isEmpty(Model.Usuario.xToken)) {
        //    return options.fn(this); 
        //}
        //return options.inverse(this);
    });

    Handlebars.registerHelper("foreach", function (arr, options) {
        if (options.inverse && !arr.length)
            return options.inverse(this);

        return arr.map(function (item, index) {
            item.$index = index;
            item.$first = index === 0;
            item.$last = index === arr.length - 1;
            return options.fn(item);
        }).join('');
    });

    Handlebars.registerHelper('printPlanMessageByCategory', function (value) {
        var text = '';

        switch (value) {
            case 'C':

                text = 'Tu credencial es Classic. Para obtener Acceso Digital es necesario que seas titular o adicional Black o titular Premium.';
                break;

            case 'P':

                text = 'Tu credencial es adicional Premium. Para obtener Acceso Digital bonificado es necesario que la credencial sea titular.';
                break;

            default:

                text = 'Para obtener Acceso Digital es <br> necesario que seas titular o <br> adicional Black o titular Premium. <br /> <strong>Seleccioná un plan para seguir <br> navegando  <nobr>LA NACION</nobr> sin límites:</strong>';
                break;
        }

        return new Handlebars.SafeString(text);
    });


    Handlebars.registerHelper('ContextEmbedHide', function (options) {
        if (Model.Embed.Mobile || Model.Embed.Article) {
            return options.inverse(this);
        } else {
            return options.fn(this);
        }
    });

    Handlebars.registerHelper('ContextEmbedShow', function (options) {
        if (Model.Embed.Mobile || Model.Embed.Article) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('ArticleContextHide', function (options) {
        if (Model.Embed.Article) {
            return options.inverse(this);
        } else {
            return options.fn(this);
        }
    });

    Handlebars.registerHelper('ArticleContextShow', function (options) { //Posiblemente deprecado
        if (Model.Embed.Article) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('landing-moreinfo-html', function (options) {
        if (Model.Landing.TipoMasInfo == 'html') {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });
    
    Handlebars.registerHelper('landing-moreinfo-iframe', function (options) {
        if (Model.Landing.TipoMasInfo == 'iframe') {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('landing-combo-link', function (combo) {
        return AppendToUrl(urlBuilder(Config.urlRedirect + combo + '/?'), 'campaign', Model.Landing.IdCampania);
    });

    Handlebars.registerHelper('get-plan-by-combo', function (combo, options) {
            let p = Model.getPlan(combo);
            if (p)
                return options.fn(p);
            else
                return options.inverse(this);
    });


    Handlebars.registerHelper('get-label-for-month', function (meses) {
        if (!meses) return '';
        if (meses === 1) { return 'mes'; } else {
            return 'meses';
        }
    });


    Handlebars.registerHelper('ceil', function (price) {
          if (isNullOrUndefined(price)) return '';
                return new Handlebars.SafeString(Math.ceil(price));
    });

    Handlebars.registerHelper('IsCheckedNewsletter', function (id, options) {
        if (Model.IsCheckedNewsletter(id))
            return options.fn();
        else
            return options.inverse();
    });
    // ==================================================
    // Bindings de eventos para pantallas 
    // ================================================== 
    Helper.asociarCredencialBindings = function () {
        $(".num-cred").autotab();
        $('select').niceSelect();

        $("#nro-credencial-1, #nro-credencial-2, #nro-credencial-3").on("keydown", function (e) {
            // Solo permito ingresar numero y enter . 
            var keycode = event.which;


            if ((e.ctrlKey && keycode == 67) || (e.ctrlKey && keycode == 86)) return true;

            if ((keycode == 13 || keycode == 32 || keycode == 107 || keycode == 190 || keycode == 188 || keycode == 189 || keycode == 109 || (keycode >= 65 && keycode <= 90))) {
                e.preventDefault();
                return false;
            }
        })

        $("#nro-credencial-1").on("keyup focusout", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));
            else if (Validation.Validators.credencialClub1.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);
            else Helper.changeStatus($(this), false);
        })

        $("#nro-credencial-2").on("keyup focusout", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));
            else if (Validation.Validators.credencialClub2.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);
            else Helper.changeStatus($(this), false);
        })

        $("#nro-credencial-3").on("keyup focusout", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));
            else if (Validation.Validators.credencialClub3.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);
            else Helper.changeStatus($(this), false);
        })

        $('#nro-documento').on('keypress', function (e) {
            var optionSelected = $("#tipo-documento option:selected").data('validator');
            if (this.value.length >= Validation.Validators.Max[optionSelected]) return false;
        });

        $('#tipo-documento').on('change', function (e) {
            var optionSelected = $("#tipo-documento option:selected").val();
            (optionSelected == 'PAS') ? $("#nro-documento").attr('type', 'text') : $("#nro-documento").attr('type', 'number');
        });

        // Eventos de popup credencial dos últimos números . 
        // TODO : ver si puede ir en formularios.js
        $("b.burbuja").click(function () {
            $(".burbuja-inner").toggle();
        });
        $(document).on("click", function (e) {
            if ($(e.target).is("b.burbuja, .burbuja-inner") === false) {
                $(".burbuja-inner").hide();
            }
        });

        // Dependiendo el modo y cantidad de credenciales levantadas cargo en inputs valor de credencial . 

        switch (Model.Usuario.TipoAsociarCredencial) {
            case "1":
                if (Model.Usuario.Credenciales.length == 1) {
                    var credencialAsociada = LN.Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "");
                    $("#nro-credencial-1").prop("readonly", true).val(credencialAsociada.substring(0, 6));
                    Helper.changeStatus($("#nro-credencial-1"), true);
                    $("#nro-credencial-2").attr("type", "text").prop("readonly", true).val("XXXXXXXX");
                    Helper.changeStatus($("#nro-credencial-2"), true);
                    $("#nro-credencial-3").focus().click();
                    $(".nro-credencial").removeClass("completa");
                    $("#asociar_tarjeta").addClass("cargado");
                }
                break;
            case "2":
                (Model.Cliente.numeroDocumento == "") ? $("#nro-documento").focus().click() : $("#nro-credencial-1").focus().click();
                break;
        }
    }

    Helper.SetFocus = function (step, name) {
        $(LN.Model.getInputsBy(step, name).get().object).focus();
    }

    Helper.HideVincularTarjetaForm = function () {
        $(document).ready(function () {
            $('.vincular-tarjeta-form').hide();
        });
    }

    Helper.HideSubTituloTarjetaForm = function () {
        $('.subtituloCodigo').hide();
    }

    Helper.resetGif = function (cb) {
        console.log('reset');
        $('body').append("<img id='varnishReset' src='http://www.lanacion.com.ar/apw/api/v1/reset.gif' style='display:none;'>");
        var img = document.querySelector('#varnishReset');
        var cbSleep = function () {
            setTimeout(
                function () {
                    cb()
                }, 5000)
        };

        if (img.complete) {
            console.log('completed');
            cbSleep();
        } else {
            $(img).on('load', function () {
                console.log('load');
                cbSleep()
            });
            $(img).on('error', function () {
                console.log('err');
                cb();
            });
        }
    }


    Helper.resetImg = function (id,url,cb) {
        $('body').append("<img id='" + id + "' src='" + url+"' style='display:none;'>");
        let img = document.querySelector('#' + id);
        const cbSleep = function () {
            setTimeout(
                function () {
                    cb()
                }, 3000)
        };

        if (img.complete) {
            console.log('completed ' + url);
            cbSleep();
        } else {
            $(img).on('load', function () {
                console.log('load ' + url);
                cbSleep()
            });
            $(img).on('error', function () {
                console.log('err ' + url);
                cb();
            });
        }
    }

    Helper.BtnGoogle = function () {
        document.body.classList.add("googleBtn");
        const $divGoogle = document.querySelector('.googlepay');
        const $p = document.createElement("span");
        const $p2 = document.createElement("span");
        $p.innerHTML = 'O bien';
        $p2.innerHTML = Constantes.LeyendaPrecioSWG;
        $p2.style.fontSize = "13px";
        $divGoogle.appendChild($p);
        GoogleSubscribe.drawButton('googlepay');
        $divGoogle.appendChild($p2);
    };

    Helper.trackPaywallView = function () {
        Analytics.trackViewPaywall();
    }

    Helper.getPaywallVariant = function () {
        var variant = Helper.getVariant();

        if (!variant) {
            variant = 'A';
        }

        return variant;
    };

    Helper.getVariant = function () {
        //return Helper.readCookie('abgroup');
        return 'A';
    };

})(LN.Helper, LN.Config, LN.View, LN.Model, Handlebars, window.config.Constantes, LN.Validation, LN.Message, LN.Controller, LN.Analytics, jQuery, LN.IFrames, LN.Hotjar);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/helper.js